<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Exercise' }" :replace="true">返回</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type == 0 ? '我的题库' : '校本题库' }}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="mine_header p_f_a p_m_t_30">
				<div class=" header_left p_flex p_f_a p_f_c">
					<div class="p_flex p_f_a small_hand"></div>
					<el-button class="heaer_btn" type="success" @click="goBack">确定添加</el-button>
				</div>
			</div>
			<div class="mine_comm p_m_t_20" v-if=" !forbid"><mine-header :forbid="forbid" @headerindexs="headerindexs" @headerindexss="headerindexss" :o="o"></mine-header></div>
		</div>

		<div class="mine_list p_m_t_20 overflow" :style="{ height: height + 'px' }"><exercise-list :age="age" :ages="ages" @change="change"></exercise-list></div>
	</div>
</template>

<script>
import MineHeader from '../commponents/mineHeader.vue';
import ExerciseList from '../commponents/exerciseList.vue';
export default {
	name: 'ExerciseAdd',
	components: {
		MineHeader,
		ExerciseList
	},

	data() {
		return {
			type: 0,
			o: '',
			age: 0,
			ages: 0,
			ccc: '',
			i: [], //已选择好的数组,
			forbid: false,
			height:0
		};
	},
	created() {
		if (JSON.parse(this.$route.query.name) && JSON.parse(this.$route.query.names)) {
			this.age = JSON.parse(this.$route.query.name);
			this.ages = JSON.parse(this.$route.query.names);
			this.ccc = this.$route.query.ccc;
		}
	},
	mounted() {
		this.type = this.$route.params.type;
		if (this.$route.query.forbid) {
			this.forbid = true;
		} else {
			this.forbid = false;
		}

		if (this.$route.params.type == 0) {
			this.o = 2;
		} else {
			this.o = 1;
		}
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/ExerciseAdd') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
				var height = box - head + 200
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		change(i) {
			// console.log(i)
			this.i = i;
		},
		headerindexss(i) {
			// console.log(i)
			this.ages = i;
		},
		headerindexs(i) {
			// console.log(i);
			this.age = i;
		},
		goBack() {
			if (this.i.length != 0) {
				this.$router.push({
					path: '/Exercise',
					query: {
						id: this.i,
						jkh: this.age,
						hjs: this.ages,
						ccc: this.ccc
					}
				});
			} else {
				this.$message.error('请选择要添加的!');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.mine_header {
	background-color: #fafafa;
	height: 60px;
}
.header_left {
	height: 100%;
}
.heaer_btn {
	margin-left: auto;
	margin-right: 230px;
}
.mine_comm {
	padding: 0 230px;
	background-color: #ffffff;
}
.mine_list {
	// padding: 0 220px;
	background-color: #ffffff;
	// height: 600px;
	padding: 0 ;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/mine/exerciseAdd.vue